// Module
var code = "<div class=\"rb-audio rb-widget\"><div class=\"rb-title\"><i class=\"ficon-app-audio\"></i><span translate=\"rubric-widget-audio_audio-response\"></span></div></div>";
// Exports
module.exports = code;